var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagDominicanRepublic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_15450)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.550781 20.1738C2.02816 25.6553 6.34422 29.9714 11.8257 31.4488V20.1738H0.550781Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8257 0.55127C6.34422 2.02858 2.02809 6.34471 0.550781 11.8261H11.8257V0.55127H11.8257Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4488 11.8261C29.9715 6.34471 25.6554 2.02858 20.1739 0.55127V11.8262H31.4488V11.8261Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1739 31.4488C25.6554 29.9714 29.9715 25.6553 31.4489 20.1738H20.1739V31.4488Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1739 16.0001C20.1739 18.3054 18.3053 20.174 16 20.174C13.6948 20.174 11.8261 18.3054 11.8261 16.0001C11.8261 13.6949 16 11.8262 16 11.8262C16 11.8262 20.1739 13.6949 20.1739 16.0001Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8261 16.0001C11.8261 13.6949 13.6948 11.8262 16 11.8262C18.3053 11.8262 20.1739 13.6949 20.1739 16.0001",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6522 13.9131V16.5218C13.6522 17.8185 14.7033 18.8696 16 18.8696C17.2967 18.8696 18.3478 17.8185 18.3478 16.5218V13.9131H13.6522Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_15450"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagDominicanRepublic);
export default __webpack_public_path__ + "static/media/flag_dominican_republic.f265ceda4249ea8209f32ecc349d953d.svg";
export { ForwardRef as ReactComponent };